import { render, staticRenderFns } from "./AppInfoCard.vue?vue&type=template&id=453cda80&scoped=true&"
import script from "./AppInfoCard.vue?vue&type=script&lang=js&"
export * from "./AppInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoCard.vue?vue&type=style&index=0&id=453cda80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453cda80",
  null
  
)

export default component.exports